<template>
  <div class="app-container">
    <transition name="el-fade-in-linear">
      <div v-if="!detailShow">
        <el-card class="custom-card mb-20" shadow="never">
          <el-button round type="danger" icon="el-icon-circle-plus-outline" @click="handleAdd()">添加</el-button>
        </el-card>
        <el-table
          :data="list"
          style="width: 100%"
          fit
        >
          <el-table-column align="center" label="广告商">
            <template slot-scope="{row}">
              <span>{{ row.AdvUserInfo.UserName }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="计划名称">
            <template slot-scope="{row}">
              <span>{{ row.GroupInfo.GroupName }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="计划开始时间">
            <template slot-scope="{row}">
              <span>{{ row.GroupInfo.BeginTime }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="计划结束时间">
            <template slot-scope="{row}">
              <span>{{ row.GroupInfo.EndTime }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="播放总次数">
            <template slot-scope="{row}">
              <span>{{ row.TotalPlayCount }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column align="center" label="播放总时长(秒)">
            <template slot-scope="{row}">
              <span>{{ row.TotalPlayDuration }}</span>
            </template>
          </el-table-column> -->
          <el-table-column align="center" label="操作">
            <template slot-scope="{row}">
              <el-link type="primary" @click="handleAdd(row)">编辑</el-link>
              <el-link v-if="row.GroupInfo.StatusNo === 'A'" type="danger" @click="disable(row)">禁用</el-link>
              <el-link v-if="row.GroupInfo.StatusNo === 'S'" type="success" @click="disable(row)">启用</el-link>
              <el-link type="danger" @click="del(row)">删除</el-link>
              <el-link type="primary" @click="detail(row)">详情广告</el-link>
              <el-link type="primary" @click="snedAdv(row)">下发广告</el-link>
            </template>
          </el-table-column>
        </el-table>
        <el-card class="custom-card" shadow="never">
          <el-pagination
            v-show="total>0"
            :current-page="listQuery.pageIndex"
            :page-sizes="[10,20,50,100]"
            :page-size="listQuery.pageSize"
            :total="total"
            layout="total, prev, pager, next"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </el-card>
      </div>
    </transition>
    <transition name="el-fade-in-linear">
      <plan-detail v-if="detailShow" :detail="detailData" @back="detailShow = false"/>
    </transition>

    <dialog-custom
      :centerDialogVisible="visible"
      title="添加/编辑投放计划"
      @handleCancel="handleCancel"
      @handleConfirm="handleConfirm('dataForm')"
    >
      <el-form ref="dataForm" :model="dataForm" :rules="rules" label-width="100px" class="demo-dataForm">
        <el-form-item label="计划名称" prop="GroupName">
          <el-input v-model="dataForm.GroupName" placeholder="请输入计划名称"/>
        </el-form-item>
        <el-form-item label="计划描述" prop="GroupDescription">
          <el-input v-model="dataForm.GroupDescription" placeholder="请输入计划描述"/>
        </el-form-item>
        <el-form-item label="计划开始时间及结束时间" prop="BeginTime">
          <el-date-picker
            v-model="dateArea"
            :default-time="['00:00:00', '23:59:59']"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"/>
        </el-form-item>
        <el-form-item label="广告商" prop="AdvUserId">
          <el-select v-model="dataForm.AdvUserId" placeholder="请选择广告商">
            <el-option v-for="item in usesArr" :key="item.UserId" :value="item.UserId" :label="item.UserName"/>
          </el-select>
        </el-form-item>
      </el-form>
    </dialog-custom>
  </div>
</template>
<script>
import PlanDetail from './planDetail'
import { qryUserInfo } from '@/api/user'
import DialogCustom from '@/components/DialogCustom'
import { qryGroupInfo, addGroupInfo, modGroupInfo, activeStopGroup, delGroupInfo, syncAdvToDev } from '@/api/adv'
export default {
  // 组件名称
  name: 'PutPlan',
  // 过滤器
  filters: {
  },
  // 组件
  components: {
    DialogCustom,
    PlanDetail
  },
  // props类型
  props: {
  },
  // 数据
  data() {
    return {
      detailData: null,
      detailShow: false,
      visible: false,
      list: [],
      srcList: [],
      listQuery: {
        groupName: null,
        advUserId: null,
        statusNo: null,
        pageIndex: 1,
        pageSize: 10
      },
      dataForm: {
        GroupId: 0,
        GroupName: null,
        GroupDescription: null,
        BeginTime: null,
        EndTime: null,
        AdvUserId: null
      },
      rules: {
        GroupName: [
          { required: true, message: '请输入计划名称', trigger: 'blur' }
        ],
        BeginTime: [
          { required: true, message: '请选择开始时间', trigger: 'blur' }
        ],
        AdvUserId: [
          { required: true, message: '请选择代理商', trigger: 'blur' }
        ]
      },
      url_: process.env.BASE_API,
      dateArea: [],
      usesArr: [], // 广告商用户列表
      total: 0
    }
  },
  // 计算属性
  computed: {
  },
  // 计算属性监听
  watch: {
    dateArea(value) {
      console.log(value)
      if (value) {
        this.dataForm.BeginTime = value[0]
        this.dataForm.EndTime = value[1]
      } else {
        this.dataForm.BeginTime = null
        this.dataForm.EndTime = null
      }
    }
  },
  // 创建时
  created() {
    this.getList()
  },
  // 挂载完毕
  mounted() {
  },
  // 方法
  methods: {
    // 下发广告
    snedAdv(row) {
      console.log(row)
      syncAdvToDev({ GroupId: row.GroupInfo.GroupId }).then(res => {
        this.$message.success('下发成功')
        this.getList()
      })
    },
    // 详情广告
    detail(item) {
      this.detailData = item
      this.detailShow = true
    },
    // 禁用启用
    disable(item) {
      activeStopGroup({ GroupId: item.GroupInfo.GroupId, StatusNo: item.GroupInfo.StatusNo === 'A' ? 'S' : 'A' }).then(res => {
        this.getList()
      })
    },
    getList() {
      qryGroupInfo(this.listQuery).then(res => {
        this.list = res.LsList
        this.total = res.TotalRows
      })
    },
    async handleAdd(item) {
      const res = await qryUserInfo({ roleId: 7, pageIndex: 1, pageSize: 2 ** 31 - 1 })
      this.usesArr = res.LsList
      if (item) {
        for (const key in this.dataForm) {
          this.dataForm[key] = item.GroupInfo[key]
        }
        this.dataForm.AdvUserId = item.AdvUserInfo.UserId
        this.dateArea = [item.GroupInfo.BeginTime, item.GroupInfo.EndTime]
      }
      this.visible = true
    },
    del(item) {
      delGroupInfo({ Id: item.GroupInfo.GroupId }).then(res => {
        this.$message.success('删除成功')
        this.getList()
      })
    },
    handleCancel() {
      this.dataForm = {
        GroupId: 0,
        GroupName: null,
        GroupDescription: null,
        BeginTime: null,
        EndTime: null,
        AdvUserId: null
      }
      this.dateArea = []
      this.visible = false
    },
    handleConfirm(dataForm) {
      this.$refs[dataForm].validate(valid => {
        if (valid) {
          if (this.dataForm.GroupId) {
            modGroupInfo(this.dataForm).then(res => {
              this.$message.success('修改成功')
              this.handleCancel()
              this.getList()
            })
          } else {
            addGroupInfo(this.dataForm).then(res => {
              this.$message.success('添加成功')
              this.handleCancel()
              this.getList()
            })
          }
        }
      })
    },
    uploadSuccess(value) {
      console.log(value)
      this.dataForm.pic = this.url_ + value
      console.log(this.dataForm)
    },
    handleSizeChange(e) {
      this.listQuery.pageSize = e
      this.getList()
    },
    handleCurrentChange(e) {
      this.listQuery.pageIndex = e
      this.getList()
    }
  }
}
</script>

<style lang='less' scoped>
</style>
